import {fetchUserJobDetails} from 'app/jobs/slice';

import type {StoreType} from 'app/store/AppStore';

export function handleUserjobUpdate(
  event: string,
  {data}: {data: {job_url: string}},
  sendMessage: unknown,
  store: StoreType
) {
  return store.dispatch(fetchUserJobDetails(data.job_url));
}
